import api from './api';
import { getCountry, getCountryCode } from './country';

export const trackedJobUrl = (jobId, source = 'linkedin') => {
  const url = new URL(`/${getCountry().slug}/jobs/${jobId}`, window.location.origin);
  url.searchParams.set('utm_source', source);
  url.searchParams.set('utm_medium', 'social');
  url.searchParams.set('utm_campaign', 'job_share');
  url.searchParams.set('utm_content', `${getCountryCode().toLowerCase()}_job_${jobId}`);
  return url.toString();
};

const track = (jobId, channel) => api.post(`/jobs/${jobId}/share`, { channel }).catch(() => {});

export const shareOnLinkedIn = job => {
  track(job.id, 'linkedin');
  const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(trackedJobUrl(job.id))}`;
  window.open(shareUrl, 'linkedin-share', 'noopener,noreferrer,width=720,height=680');
};

export const shareJob = async job => {
  const url = trackedJobUrl(job.id, 'share');
  if (navigator.share) {
    track(job.id, 'native');
    await navigator.share({ title:`${job.title} en ${job.company_name}`, text:'Mira esta vacante en TalentosRD', url });
    return 'shared';
  }
  track(job.id, 'copy');
  await navigator.clipboard.writeText(url);
  return 'copied';
};
